<template>
  <div class="register-wrap" v-if="code">
    <authLeft />
    <div class="register-right">
      <!-- <div class="register-form" v-if="mode=='verifyEmail'">
        <div class="register-form-title">メールアドレスの認証完了</div>
        <img class="register-form-img" src="../../assets/authentication.png" alt />
        <div>
          <div>メールアドレスの認証が完了しました。</div>
          <router-link to="/login">
            <el-button style="width:100%; margin-top:30px;" type="primary">ログイン画面へ</el-button>
          </router-link>
        </div>
      </div> -->
      <div class="register-form" v-if="check_loading">
        <div class="register-form-title">REECH DATABASEへようこそ</div>
        <div class="flex-row">
          登録処理中です...
          <div class="loader--mini blue"></div>
        </div>
      </div>
      <div class="register-form" v-else-if="!error">
        <div class="register-form-title">REECH DATABASE - パスワード設定</div>
        <div style="color: #666; margin-bottom: 30px">REECH DATABASE用のパスワードを設定して登録を完了させてください</div>
        <div class="register-form-subtitle">パスワード</div>
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item prop="pass">
            <el-input placeholder="パスワード" v-model="form.pass" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <div class="register-form-subtitle">パスワード(再入力)</div>
          <el-form-item prop="checkPass">
            <el-input placeholder="パスワード(再入力)" v-model="form.checkPass" type="password" autocomplete="off" @change="register()"></el-input>
          </el-form-item>
          <el-button style="width:100%; margin-top:30px;" type="primary" @click="register()" :disabled="loading">
            <div class="flex-row">
              パスワードを設定して登録を完了
              <div class="loader--mini" v-show="loading"></div>
            </div>
          </el-button>
        </el-form>
      </div>
      <div class="register-form" v-else>
        <div class="register-form-title">REECH DATABASE - パスワード設定</div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import authLeft from "./auth_left";
const root = process.env.VUE_APP_API;
const mode = process.env.VUE_APP_MODE;
const thirdpartyAppRegisterAPI = root + "/api/thirdparty/colorme/register";
const checkAPI = root + "/api/thirdparty/colorme/check";
const loginAPI = root + "/api/auth/login";
// const loginNotificationAPI = root + "/api/mail/login_notification";
const protocol = window.location.protocol; // "http:" または "https:"
const hostname = window.location.hostname; // "127.0.0.1"
const port = window.location.port; // "8080"
const fullUrl = `${protocol}//${hostname}${port ? ':' + port : ''}`;

export default {
  name: "register",
  components: {
    authLeft,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワードは必須です"));
      } else {
        if (this.form.checkPass !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワード(再入力)は必須です"));
      } else if (value !== this.form.pass) {
        callback(new Error("パスワードが一致しません"));
      } else {
        callback();
      }
    };
    return {
      code: "",
      error: false,
      loading: false,
      check_loading: true,
      email: "",
      form: {
        pass: "",
        checkPass: "",
      },
      token: "",
      shop: [],
      rules: {
        pass: [
          { required: true, message: "パスワードは必須です", trigger: "blur" },
          { min: 8, message: "パスワードは8文字以上で設定してください", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.code = this.$route.query.code;
    if (!this.code) {
      if (mode == "prod") {
        var root_url = "https://database.reech.co.jp";
      } else {
        root_url = "http://127.0.0.1:8080";
      }
      location.href =
        "https://api.shop-pro.jp/oauth/authorize?client_id=26e2b619e1b03483579d1709555fb951fc69a2c62317dc2af394aab903dfe295&redirect_uri=" +
        root_url +
        "/auth/thirdapp&response_type=code&scope=read_sales";
    } else {
      this.registerCheck();
    }
  },
  methods: {
    registerCheck() {
      this.check_loading = true;
      var params = new URLSearchParams();
      params.append("code", this.code);
      this.axios.post(checkAPI, params).then((response) => {
        if (response.data.status == "exist") {
          this.email = response.data.client.email;
          this.token = response.data.client.token;
          this.form.pass = response.data.pass;
          this.login();
        } else if (response.data.status == "OK") {
          this.shop = response.data.shop;
          this.check_loading = false;
        } else {
          this.error = true;
          this.check_loading = false;
        }
      });
    },
    register() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true;
          var params = new URLSearchParams();
          // params.append("token", this.token);
          params.append("pass", this.form.pass);
          params.append("shop", JSON.stringify(this.shop));
          this.axios
            .post(thirdpartyAppRegisterAPI, params)
            .then((response) => {
              if (response.data.status == "NG") {
                console.log("error");
              } else if (response.data.status == "email_exist") {
                this.$message({
                  message: "このショップのメールアドレスは既に登録されています",
                  type: "error",
                  offset: 7,
                  showClose: true,
                });
              } else {
                this.email = response.data.registered_data.email;
                this.token = response.data.registered_data.token;
                this.login();
              }
            })
            .catch(() => {});
        } else {
          this.$message.error("項目を正しく入力してください");
          this.loading = false;
        }
      });
    },
    login() {
      this.$store.dispatch("reset");
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.form.pass)
        .then(() => {
          this.axios
            .get(loginAPI, {
              params: {
                user_token: this.token,
                accessUrl: fullUrl,
              },
            })
            .then(() => {
              this.$store.dispatch("getUserData", { token: this.token, user_token: this.token }).then(() => {
                setTimeout(() => {
                  this.$router.push("/dashboard");
                }, 2000);
              });
            });
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("メールアドレスかパスワードが間違っています。");
        });
    },
  },
};
</script>
